<style>
.bg-primary {
  background-color: #1a3665 !important;
}

.white{
  background-color: white;
}
/* enable absolute positioning */
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .fa-search {
  position: absolute;
  pointer-events: none;
}

.right-addon .fa-search {
  left: 10px;
  margin-top: 10px;
}

.right-addon input {
  padding-left: 30px;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Catatan Aktivitas
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            v-model.number="pageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol class="table-responsive mt-3">
          <!-- <table class="table table-inverse bg-white">
            <thead class="thead-inverse border-top-0 bg-primary text-white">
              <tr>
                <th>No</th>
                <th>Date</th>
                <th>Host</th>
                <th>Content</th>
              </tr>
            </thead>
          </table> -->
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
            </template>
            <template #created_at="{item}">
              <td class="py-2">
                {{ item.created_at }}
              </td>
            </template>

            <template #log_by_name="{item}">
              <td class="py-2">
                {{ item.log_by_name ? item.log_by_name : '-' }}
              </td>
            </template>

            <template #keterangan="{item}">
              <td class="py-2">
                {{ item.keterangan ? item.keterangan : '-' }}
              </td>
            </template>

            <template #aksi="{item, index}">
              <td class="py-2">
               
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
          />
          <div class="row">
          <div class="col-6 text-left d-flex align-items-center">
            <div class="font-weight-bold ml-4">514.104 Result Found</div>
          </div>
        </div>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import LogActivityService from '../../services/logactivity/log-activity.service'
import { Pagination } from '../../mixins/Pagination'

const fields = [
  { key: "no" },  
  {
    key: 'log_by_name',
    label: 'Nama'
  },
  {
    key: 'detail',
    label: 'Menu'
  },
  {
    key: 'keterangan',
    label: 'Keterangan',
  },
  {
    key: "created_at",
    label: 'Date',
    _style: "text-align: left;"
  },  
    
];

export default {
  mixins : [Pagination],
  data() {
    return {
      fields
    }
  },
  mounted() {
    this.getData(0,10,'default');
  },
  methods : {
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      LogActivityService.getLogActivity(currentPage,pageSize,filter)
      .then(response => {
        this.items = response.data.data.content;
        this.pagination.totalPages = response.data.data.totalPages;
        this.currentPage = response.data.data.pageable.pageNumber + 1;

        loader.hide()
      }).catch(error => {
        // comment console console.log(error)
        loader.hide()
      })
    }
  }
}
</script>